import React from 'react';

export default function () {
  return (
    <a
      href="https://bredbånd.no?utm_source=nettbureau&utm_medium=strom-no&utm_campaign=kvittering_single_ad"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
    >
      <div className="nb-order--page-box nb-order--page-box--keep-borders nb-order--page-box--hover-dropshadow nb-extras nb-extras--singel-ad nb-extras--blue">
        <div className="nb-extras--pretext">
          <h2 style={{ textDecoration: 'none' }}>Se om du kan få billigere og raskere internett!</h2>
        </div>
        <div className="nb-extras--2">
          <div className="nb-extras--item" style={{ width: '100%' }}>
            <div className="nb-extras--item-body">
              <div className="nb-extras--item-image-wrapper">
                <img alt="" src="https://fatcamp.io/cms.nettbureau.no/uploads/1674467302_f83f8d9941.jpg?width=666" className="nb-extras--item-image" />
              </div>
              <div className="nb-extras--item-text">
                <p style={{ color: '#484848' }}>
                Få bredbånd fra 299,-/mnd. Se hvem som kan levere raskeste og billigste nett der du bor.
                </p>
              </div>
              <span className="nb-extras--btn nb-extras--btn-orange">Ja, jeg ønsker gode tilbud!</span>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
}
